import { PersonalInfo, Project, Experience, Education, Skill } from "../types";
import { Language } from "../contexts/LanguageContext";

// Fonction pour obtenir les données traduites selon la langue
export const getTranslatedData = (language: Language, t: (key: string) => string) => {
  
  const personalInfo: PersonalInfo = {
    name: "Tomm JOBIT",
    title: t('data.personalInfo.title'),
    bio: t('data.personalInfo.bio'),
    profileImage: `${process.env.PUBLIC_URL}/assets/profile.jpg`,
    contact: {
      email: "tommjobit@live.fr",
      phone: "+33 6 41 66 65 87",
      linkedin: "https://linkedin.com/in/tjobit",
      github: "https://github.com/tjobit",
    },
  };

  const skills: Skill[] = [
    {
      category: t('data.skills.categories.frontend'),
      skills: [
        "HTML5",
        "CSS3",
        "JavaScript",
        "Typescript",
        "React",
        "Vue",
        "Tailwind CSS",
        "Responsive Design",
      ],
    },
    {
      category: t('data.skills.categories.backend'),
      skills: [
        "Node.js",
        "Express",
        "PHP",
        "Symfony",
        "Python",
        "Django",
        "Java",
        "MySQL",
        "MongoDB",
        "PostgreSQL",
      ],
    },
    {
      category: t('data.skills.categories.tools'),
      skills: ["Git", "GitHub", "VSCode", "Docker", "NPM", "Figma"],
    },
    {
      category: t('data.skills.categories.soft'),
      skills: [
        t('data.skills.softSkills.learning'),
        t('data.skills.softSkills.curiosity'),
        t('data.skills.softSkills.teamwork'),
        t('data.skills.softSkills.rigor'),
        t('data.skills.softSkills.adaptability'),
      ],
    },
  ];

  const projects: Project[] = [
    {
      id: "1",
      title: "Dropy",
      description: language === 'fr' 
        ? "Dropy facilite les rencontres en connectant les personnes qui fréquentent les mêmes lieux : partagez un média à votre position et laissez les autres découvrir et engager la conversation avec vous."
        : "Dropy facilitates meetings by connecting people who frequent the same places: share media at your location and let others discover and start conversations with you.",
      technologies: [
        "React-Native",
        "TypeScript",
        "Node.js",
        "PostgreSQL",
        "Prisma",
      ],
      imageUrl: `${process.env.PUBLIC_URL}/assets/dropy-project.jpg`,
      githubUrl: "https://github.com/dropy-project",
    },
    {
      id: "2",
      title: "IUT Onboarding",
      description: language === 'fr'
        ? "IUT Onboarding est un panneau d'affichage numérique pour les étudiants, centralisant météo, cours, menus CROUS et horaires des transports, directement accessible dans le hall de l'IUT informatique de Bordeaux."
        : "IUT Onboarding is a digital display board for students, centralizing weather, courses, CROUS menus and transport schedules, directly accessible in the hall of the computer science IUT in Bordeaux.",
      technologies: ["VueJS", "Javascript", "Raspberry PI", "Cheerio"],
      imageUrl: `${process.env.PUBLIC_URL}/assets/iut-onboarding.png`,
      githubUrl: "https://github.com/gfroidcourt/iut-onboarding",
      liveUrl: "https://iutonboarding.duckdns.org/info/",
    },
    {
      id: "3",
      title: "Asso Card",
      description: language === 'fr'
        ? "Terminal de paiement électronique pour le bar étudiant de l'IUT informatique de Bordeaux : permet de créditer facilement une carte NFC pour acheter des snacks, avec des transactions plus rapides et une meilleure fréquentation du bar."
        : "Electronic payment terminal for the student bar at Bordeaux computer science IUT: allows easy NFC card crediting for snack purchases, with faster transactions and better bar attendance.",
      technologies: ["HTML5", "CSS3", "Javascript", "Flask", "Raspberry PI"],
      imageUrl: `${process.env.PUBLIC_URL}/assets/asso-card.png`,
      githubUrl: "https://github.com/celian-rib/payment-terminal-raspi",
    },
  ];

  const experiences: Experience[] = [
    {
      id: "1",
      company: "STMicroelectronics",
      position: t('data.positions.apprenticeEngineer'),
      startDate: "2022-09-01",
      endDate: "2025-09-01",
      description: language === 'fr' ? [
        "Développement d'un outil bureau pour le débogage de solutions embarquées avec Electron, React et Express",
        "Conception d'un système de télémétrie pour outils web basé sur Node, Express et npm",
        "Réalisation de tests unitaires avec Jest-ts, Chai, Sinon",
        "Travail en équipe selon la méthodologie Scrum, utilisation de Git, PowerPoint et Excel",
      ] : [
        "Development of a desktop tool for debugging embedded solutions with Electron, React and Express",
        "Design of a telemetry system for web tools based on Node, Express and npm",
        "Unit testing with Jest-ts, Chai, Sinon",
        "Teamwork using Scrum methodology, using Git, PowerPoint and Excel",
      ],
      technologies: [
        "React",
        "Electron",
        "Node.js",
        "Express",
        "TypeScript",
        "Jest",
        "Chai",
        "Sinon",
        "Git",
        "Scrum",
      ],
    },
    {
      id: "2",
      company: language === 'fr' ? "MetalMaker3D, Cracovie (Pologne)" : "MetalMaker3D, Krakow (Poland)",
      position: t('data.positions.internDeveloper'),
      startDate: "2024-05-01",
      endDate: "2024-08-01",
      description: language === 'fr' ? [
        "Création du site web de l'entreprise avec Shopify, HTML et CSS",
        "Développement d'une application web pour clients et employés avec React, TypeScript et Express",
      ] : [
        "Creation of the company website with Shopify, HTML and CSS",
        "Development of a web application for customers and employees with React, TypeScript and Express",
      ],
      technologies: [
        "React",
        "TypeScript",
        "Express",
        "HTML",
        "CSS",
        "Shopify",
        "Git",
        "Figma",
      ],
    },
    {
      id: "3",
      company: "Wedge-Digital, Bordeaux",
      position: t('data.positions.internDeveloper'),
      startDate: "2022-03-01",
      endDate: "2022-05-31",
      description: language === 'fr' ? [
        "Développement d'une solution de déploiement cloud avec Django",
        "Travail en équipe de trois personnes",
        "Utilisation de Docker et de PostgreSQL",
      ] : [
        "Development of a cloud deployment solution with Django",
        "Teamwork with three people",
        "Use of Docker and PostgreSQL",
      ],
      technologies: [
        "Django",
        "Python",
        "Docker",
        "PostgreSQL",
        "GitHub",
        "Scrum",
      ],
    },
  ];

  const education: Education[] = [
    {
      id: "1",
      school: language === 'fr' 
        ? "École Nationale Supérieure d'Ingénieurs du Mans (ENSIM)" 
        : "National Higher School of Engineers of Le Mans (ENSIM)",
      degree: language === 'fr' 
        ? "Diplôme d'ingénieur en informatique" 
        : "Computer Engineering Degree",
      startDate: "2022-09-01",
      endDate: "2025-09-01",
      description: language === 'fr'
        ? `Formation d'ingénieur en informatique à l'ENSIM Le Mans, en alternance. J'ai acquis des compétences en conception, développement et intégration de systèmes informatiques complexes, qu'il s'agisse de systèmes embarqués, applications connectées, ou d'architecture logicielle.
        La formation combine cours théoriques (algorithmique, systèmes, réseaux, base de données, etc.), travaux dirigés, nombreux travaux pratiques et projets.`
        : `Computer engineering training at ENSIM Le Mans, work-study program. I have acquired skills in design, development and integration of complex computer systems, whether embedded systems, connected applications, or software architecture.
        The training combines theoretical courses (algorithms, systems, networks, databases, etc.), tutorials, numerous practical work and projects.`,
    },
    {
      id: "2",
      school: language === 'fr' ? "Certification TOEIC" : "TOEIC Certification",
      degree: "Test of English for International Communication",
      startDate: "2024-04-01",
      endDate: "2026-04-01",
      description: language === 'fr'
        ? "Score de 950/990, attestant d'un niveau C1 en compréhension écrite et orale ainsi que l'expression écrite en anglais professionnel. Certification valable deux ans."
        : "Score of 950/990, certifying C1 level in written and oral comprehension as well as written expression in professional English. Two-year valid certification.",
    },
    {
      id: "3",
      school: language === 'fr' ? "IUT de Bordeaux-Gradignan" : "University Institute of Technology of Bordeaux-Gradignan",
      degree: language === 'fr' ? "DUT Informatique" : "DUT Computer Science",
      startDate: "2020-09-01",
      endDate: "2022-06-30",
      description: language === 'fr'
        ? `Diplôme Universitaire de Technologie en Informatique, formation de deux ans centrée sur les fondamentaux de l'informatique et du développement logiciel.  
        Le cursus couvre les bases : algorithmique, structures de données, programmation (Python, C, Java), systèmes d'exploitation, bases de données (SQL), réseaux, ainsi que des TP et mini-projets pour appliquer les connaissances.  
        Nombreux projets en équipe, utilisation des méthodes agiles (SCRUM) et des outils de versioning (Git/GitHub/Gitlab).`
        : `University Diploma of Technology in Computer Science, two-year training focused on computer science fundamentals and software development.  
        The curriculum covers the basics: algorithms, data structures, programming (Python, C, Java), operating systems, databases (SQL), networks, as well as practical work and mini-projects to apply knowledge.  
        Many team projects, use of agile methods (SCRUM) and versioning tools (Git/GitHub/Gitlab).`,
    },
    {
      id: "4",
      school: language === 'fr' ? "Lycée Jean Condorcet, Bordeaux" : "Jean Condorcet High School, Bordeaux",
      degree: language === 'fr' ? "Baccalauréat Scientifique" : "Scientific Baccalaureate",
      startDate: "2019-09-01",
      endDate: "2020-06-30",
      description: language === 'fr'
        ? "Baccalauréat scientifique, spécialité mathématiques, mention bien"
        : "Scientific baccalaureate, mathematics specialty, with honors",
    },
  ];

  return {
    personalInfo,
    skills,
    projects,
    experiences,
    education,
  };
};